import { render, staticRenderFns } from "./GlossaryConfig.vue?vue&type=template&id=bd6ff012&"
import script from "./GlossaryConfig.vue?vue&type=script&lang=js&"
export * from "./GlossaryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports